import { defineStore } from 'pinia'
import { currencyCacheKey } from '~/utils/currency'
import { fetchInfoData, type InfoData } from '~/queries'
import { useDataCache } from '#nuxt-multi-cache/composables'

type State = {
  data: InfoData | null
}

export const useHomepageStore = defineStore('homepage', {
  state: (): State => ({
    data: null,
  }),
  actions: {
    async fetch(revalidate: boolean = false) {
      if (this.data && !revalidate) return this.data

      const { domain } = useSite().site.value
      const path = '/'
      const siteStore = useSiteStore()

      try {
        if (!domain) return

        const cacheKey = currencyCacheKey('homepage-data', useCurrencyStore().code)
        const { value, addToCache } = await useDataCache(cacheKey)

        if (value && !revalidate) {
          this.data = value;
        } else {

          const response = await fetchInfoData({ domain, path })
          await addToCache(response, [`homepage:${domain}`])
          this.data = response
        }

        if (Object.prototype.hasOwnProperty.call(this.data || {}, 'straplines')) {
          siteStore.setStraplines(this.data?.straplines ?? null)
        }

        return this.data;
      } catch (error) {
        throw createError({
          statusCode: 500,
          statusMessage: 'Error fetching homepage data',
        })
      }
    },
  },
})
